export default __webpack_public_path__ + "img/2_8-33de7282.png";